import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PAYMENTS_URL } from '@webapp/core/config';
import { ButtonComponent, CardComponent, IconComponent, ToastService } from '@webapp/ui';

@Component({
  selector: 'app-issue-policy-link-success-page',
  imports: [ButtonComponent, CardComponent, IconComponent, RouterLink],
  templateUrl: './issue-policy-link-success-page.component.html',
})
export class IssuePolicyLinkSuccessPageComponent {
  private readonly paymentsUrl = inject(PAYMENTS_URL);
  private readonly toastService = inject(ToastService);

  async copyPaymentLink() {
    const stored = localStorage.getItem('activar_policy_payment_link');
    if (!stored) return;

    const token = JSON.parse(stored);
    const url = `${this.paymentsUrl}cotizacion/${token.tokenLink}`;
    try {
      await navigator.clipboard.writeText(url ?? '');
      this.toastService.showToast('Link copiado', 'El link de pago ha sido copiado al portapapeles', 'success');
    } catch {
      this.toastService.showToast('Error', 'No se pudo copiar el link', 'error');
    }
  }
}
